"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const pickers_1 = require("@material-ui/pickers");
const shiftTZLocalToX_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZLocalToX"));
const shiftTZXToLocal_1 = __importDefault(require("@opsbase/lib-time/helpers/shiftTZXToLocal"));
const react_1 = __importStar(require("react"));
const makeDatePickerInput_1 = __importDefault(require("../helpers/makeDatePickerInput"));
const makePicker_1 = __importDefault(require("../helpers/makePicker"));
const DatePickerWrapper_1 = __importDefault(require("./DatePickerWrapper"));
exports.DatePicker = (0, makePicker_1.default)((props) => {
    const { label, value, timezone, onChange, disabled } = props;
    const pickerValue = timezone ? (0, shiftTZXToLocal_1.default)(value, timezone) : value;
    const handleChange = (0, react_1.useCallback)(v => {
        onChange === null || onChange === void 0 ? void 0 : onChange(timezone ? (0, shiftTZLocalToX_1.default)(v, timezone) : v);
    }, [onChange, timezone]);
    return (react_1.default.createElement(DatePickerWrapper_1.default, null,
        react_1.default.createElement(pickers_1.DatePicker, { clearable: true, disabled: disabled, label: label, renderInput: (0, makeDatePickerInput_1.default)(pickerValue, props), value: pickerValue || null, onChange: handleChange })));
});
exports.default = exports.DatePicker;
